import React, { Component } from "react";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import LogoutIcon from "@mui/icons-material/Logout";
import styles from "../../../../styles";

const {
  HeaderMainContainer,
  HeaderNav,
  SubHeading,
  IconWhiteHover,
  BoxWrapper,
  HeaderUserContainer,
  HeaderUserNavMain,
  HeaderUserNavSub,
  UserIcon,
} = styles;

class Header extends Component {
  state = {
    accountIcon: false,
  };

  HandleLogout = (event) => {
    event.preventDefault()
    window.localStorage.removeItem('token')
    window.location.reload()
  }


  handleAccountIcon = () => {
    if (this.state.accountIcon) {
      this.setState({ accountIcon: false });
    } else {
      this.setState({ accountIcon: true });
    }
  };

  render() {
    let activeUser = this.props.activeUser;
    let currentUser = activeUser.currentUser;
    let isUserVerified = activeUser.isUserVerified;
    return (
      <React.Fragment>
        <HeaderMainContainer>
          <HeaderNav>
            <SubHeading
              style={{ color: "black", padding: "14px 20px 14px 80px" }}
            >
              {this.props.headerName || 'No name provided'}
            </SubHeading>
          </HeaderNav>
          <HeaderNav>
            <IconWhiteHover>
              <NotificationsNoneIcon />
            </IconWhiteHover>
            <IconWhiteHover onClick={this.handleAccountIcon}>
              <ManageAccountsIcon />
            </IconWhiteHover>
          </HeaderNav>
          <HeaderUserContainer
            style={
              this.state.accountIcon ? { display: "flex" } : { display: "none" }
            }
          >
            <HeaderUserNavMain>
              <UserIcon>
                {
                  isUserVerified && currentUser.firstName && currentUser.lastName
                  ? `${currentUser.firstName.split('')[0]}${currentUser.lastName.split('')[0]}`
                  : "MT"
                }
              </UserIcon>
              <span>
                {
                  isUserVerified && currentUser.firstName && currentUser.lastName
                  ? `${currentUser.firstName} ${currentUser.lastName}`
                  : "Md Husain Thekiya"
                }
                <br />
                <span style={{ color: "#67757e" }}>  
                  {
                    isUserVerified && currentUser.email
                    ? `${currentUser.email}`
                    : "hussainthekiya@gmail.com"
                  }
                </span>
              </span>
            </HeaderUserNavMain>
            {/* <HeaderUserNavSub>My Profile</HeaderUserNavSub> */}
            <HeaderUserNavSub
            onClick={this.HandleLogout}
            >
              <IconWhiteHover
                style={{ padding: "0px 10px 0px 0px", margin: "0px" }}
              >
                <LogoutIcon id="LogoutIcon"/>
              </IconWhiteHover>
              Logout
            </HeaderUserNavSub>
          </HeaderUserContainer>
        </HeaderMainContainer>
      </React.Fragment>
    );
  }
}

export default Header;
